import { createContext, useContext } from 'react'
import { Link } from 'react-router-dom'
import { DEFAULT_LOCALE, localePath } from './index'
import { DICT } from './dict'

const LocaleContext = createContext(DEFAULT_LOCALE)

export function LocaleProvider({ locale, children }) {
  return <LocaleContext.Provider value={locale}>{children}</LocaleContext.Provider>
}

// Limba curentă (din URL, setată în App).
export const useLocale = () => useContext(LocaleContext)

// Dicționarul UI pentru limba curentă (fallback en).
export function useT() {
  const locale = useContext(LocaleContext)
  return DICT[locale] || DICT[DEFAULT_LOCALE]
}

// Helper: cale prefixată cu limba curentă (pentru linkuri/navigare manuală).
export function useLocalePath() {
  const locale = useContext(LocaleContext)
  return (path) => localePath(locale, path)
}

// <Link> conștient de limbă: `to` e calea logică (ex. „/finance"), prefixarea cu /ro|/de
// se face automat după limba curentă. Pentru linkuri externe folosește <a>.
export function L({ to, ...rest }) {
  const locale = useContext(LocaleContext)
  return <Link to={localePath(locale, to)} {...rest} />
}
